/**
 * Thresholds for classifying RIASEC / facet scores into High, Low, or Some Interest.
 *
 * Two scales are in use across the product:
 *
 * 1. H&L "Check My Core" scale — 0.0 to 1.0
 *    Used for the climber's own scores, derived from facet totals as ratios.
 *    Also used (× 100) on the 0–100 percentage scale shown in some surfaces.
 *
 * 2. O*NET RIASEC scale — 1.0 to 7.0
 *    Used for hat scores authored in the CMS.
 *    Scores below 1 indicate missing data and should never be displayed.
 *
 * "Some Interest" / middle is everything between high and low and is generally
 * not surfaced.
 */

// 0.0 - 1.0 H&L Check-My-Core scale (climber scores)
export const USER_HIGH_INTEREST_THRESHOLD = 0.73;
export const USER_LOW_INTEREST_THRESHOLD = 0.27;

// 0 - 100 percentage equivalent of the H&L scale
export const USER_HIGH_INTEREST_THRESHOLD_PERCENT = 73;
export const USER_LOW_INTEREST_THRESHOLD_PERCENT = 27;

// 1.0 - 7.0 O*NET RIASEC scale (hat scores)
export const HAT_HIGH_INTEREST_THRESHOLD = 5.1;
export const HAT_LOW_INTEREST_THRESHOLD = 2.62;
export const HAT_MIN_VALID_SCORE = 1;
